<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Toko</a></li>
                <li><a href="#/pengeluaran_harian">Pengeluaran Harian</a></li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-left" style="padding-left: 20px; padding-top: 10px;">
                          <h4><b>PENGELUARAN HARIAN</b></h4>
                        </div>
                        <div class="pull-right" style="padding-right: 20px; padding-top: 10px;">
                          <el-select v-model="toko1" clearable filterable placeholder="Pilih Toko" style="width: 500px"
                              @change="handleSelect1">
                            <el-option
                              v-for="item in region"
                              :key="item.value"
                              :label="item.label"
                              :value="item">
                            </el-option>
                          </el-select>
                          <!-- <el-date-picker v-loading.fullscreen.lock="fullscreenLoading" @change='handleChangeDate' 
                            v-model="value4"
                            style="width: 120px"
                            type="month"
                            placeholder="Pilih bulan">
                          </el-date-picker> -->
                          <el-date-picker v-loading.fullscreen.lock="fullscreenLoading"
                            style="width: 250px"
                            type="daterange"
                            align="right"
                            v-model="value6"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="-"
                            start-placeholder="Awal"
                            end-placeholder="Akhir">
                          </el-date-picker>
                          &nbsp;
                          <el-button icon="el-icon-search" @click="getData()" circle></el-button>
                          <el-button circle type="primary" icon="el-icon-document" @click="downloadExcelMonth()"></el-button>
                        </div>
                    </div>
                    <div class="box-body">
                          <el-table v-loading="loadingModal" border hover
                          :summary-method="getSummaries"
                          show-summary 
                          :data="tableData1"
                          style="width: 100%" responsive>
                          <!-- <el-table-column fixed="left"
                            label="#"
                            header-align="center"
                            align="center"
                            width="50px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{row.index}}.
                              </template>
                            </template>
                          </el-table-column> -->
                          <el-table-column fixed="left"
                            label="TANGGAL"
                            prop="tanggal"
                            header-align="center"
                            align="center"
                            width="100px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_tanggal" placeholder="Filter" @keyup.native="cariTanggal()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.tanggal}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="KETERANGAN"
                            prop="nama_barang"
                            header-align="left"
                            align="left">
                            <template slot-scope="scope">
                              <!-- <template v-if="!scope.row.edit">
                                {{scope.row.nama_barang}}
                              </template> -->
                              <template v-if="scope.row.edit">
                                <el-input v-model="filter_keterangan" placeholder="Filter Keterangan" @keyup.native="filterKeterangan()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.nama_barang}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="QTY"
                            prop="qty"
                            header-align="center"
                            align="center"
                            width="80px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{toMoney(scope.row.qty)}}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="HARGA"
                            prop="unit_price"
                            header-align="left"
                            align="left"
                            width="100px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{toMoney(scope.row.unit_price)}}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="TOTAL"
                            prop="total_price"
                            header-align="left"
                            align="left"
                            width="100px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{toMoney(scope.row.total_price)}}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="JENIS"
                            prop="jenis"
                            header-align="left"
                            align="left"
                            width="80px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{scope.row.jenis}}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="STATUS"
                            prop="status"
                            header-align="center"
                            align="center"
                            width="90px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                <span v-if="scope.row.approve === 'T'"><i class="el-icon-close" style="color: #F56C6C"></i></span>
                                <span v-else><i class="el-icon-check" style="color: #67C23A"></i></span>
                              </template>
                            </template>
                          </el-table-column>

                          <el-table-column label="PILIHAN" align="center" header-align="center" width="250px" v-if="level.indexOf('ADMIN') !== -1 || level.indexOf('ROOT') !== -1">
                            <!-- <template slot-scope="scope">
                              <el-tooltip v-if="scope.row.edit1" class="item" effect="dark" content="Ok" placement="top-start">
                                <el-button type="success" size="small" icon="el-icon-check"  @click="confirmEdit1(scope.$index, scope.row, ('form' + scope.$index))"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Detail" placement="top-start">
                                <el-button type="primary" size="small" icon="ti-eye"  @click="confirmDet(scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="scope.row.edit1" class="item" effect="dark" content="Cancel" placement="top-start">
                                <el-button size="small" icon="el-icon-error" type="warning" @click="cancelEdit(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                            </template> -->

                            <template slot-scope="scope">
                              <el-tooltip v-if="scope.row.approve === 'Y' && !scope.row.edit" class="item" effect="dark" content="Tolak" placement="top-start">
                                <el-button type="danger" size="small" icon="el-icon-error" @click="confirmDel(scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="scope.row.approve === 'T' && !scope.row.edit" class="item" effect="dark" content="Terima" placement="top-start">
                                <el-button type="success" size="small" icon="el-icon-check" @click="confirmAcc(scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Ubah Jenis" placement="top-start">
                                <el-button type="primary" size="small" icon="el-icon-refresh" @click="confirmUbah(scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Edit" placement="top-start">
                                <el-button type="primary" size="small" icon="el-icon-edit" @click="confirmEdit2(scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Log" placement="top-start">
                                <el-button type="primary" size="small" icon="el-icon-time" @click="confirmLog(scope.row)"></el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>

                      <br/>

                        <!-- <div align="right">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="tableData.length"
                            :page-size="page_size"
                            :current-page="current_page"
                            @current-change="handleCurrentChange" >
                          </el-pagination>
                        </div> -->


                    </div>
                </div>

                <el-dialog title="Tambah Saving" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd" width="35%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formAdd" :label-width="formLabelWidth" class="demo-ruleForm"> @submit.prevent=""
                    <el-form-item label="Tanggal" prop="tanggal">
                      <el-date-picker
                        v-model="row1.tanggal"
                        type="date">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Keterangan" prop="nama">
                      <el-select v-model="row1.nama" placeholder="Pilih Keterangan" style="width: 300px" >
                        <el-option
                          v-for="item in namas"
                          :key="item.kode"
                          :label="item.nama"
                          :value="item.nama">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="Jumlah" prop="jumlah">
                      <el-input type="text" v-model="row1.jumlah" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formAdd')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Edit Wilayah" :visible.sync="dialogFormEdit" v-loading="loadingModalEdit" width="35%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formEdit" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Nama" prop="nama">
                      <el-input type="text" v-model="row1.nama" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Jumlah" prop="jumlah">
                      <el-input type="text" v-model="row1.jumlah" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Tanggal" prop="tanggal">
                      <el-date-picker
                        v-model="row1.tanggal"
                        type="date">
                      </el-date-picker>
                    </el-form-item>
                  </el-form>
                  <el-table v-loading="loadingModalAdmin" border hover
                    :data="pegawai"
                      highlight-current-row
                      @current-change="handleCurrentChangePegawai"
                    style="width: 100%" responsive>
                    <el-table-column fixed="left"
                      label="#"
                      min-width="50">
                      <template slot-scope="scope">
                          {{scope.$index + 1}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="SKU"
                      min-width="300">
                      <template slot-scope="scope">
                          {{scope.row.sku}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="Nama"
                      min-width="300">
                      <template slot-scope="scope">
                          {{scope.row.nama}}
                      </template>
                    </el-table-column>
                  </el-table>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEdit = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formEdit')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel" v-loading="loadingModalDel" width="500px" top="1%">
                  <h4>Apakah Anda yakin akan menolak pengeluaran <b>{{ keterangan }}</b>?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilDel = false">Batal</el-button>
                    <el-button type="primary" @click="confirmDel1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormAcc" v-loading="loadingModalAcc" width="500px" top="1%">
                  <h4>Apakah Anda yakin akan menerima pengeluaran <b>{{ keterangan }}</b>?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormAcc = false">Batal</el-button>
                    <el-button type="primary" @click="confirmAcc1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormUbah" v-loading="loadingModalUbah" width="500px" top="1%">
                  <h4>Apakah Anda yakin akan melakukan perubahan jenis pengeluaran <b>{{ form1.name }}</b>?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormUbah = false">Batal</el-button>
                    <el-button type="primary" @click="confirmUbah1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Informasi" :visible.sync="dialogFormInfo" width="500px" top="1%">
                  <h5>{{message}}</h5>
                  <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="dialogFormInfo = false">Batal</el-button> -->
                    <el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
                  </span>
                </el-dialog>


                <el-dialog :title="title" :visible.sync="dialogDet" v-loading="loadingModalDet" width="700px" top="1%">
                  <el-table border hover
                    :data="tableData7"
                    style="width: 100%; padding-bottom: 1px;" responsive>
                    <el-table-column
                      label="TANGGAL"
                      prop="tanggal"
                      header-align="center"
                      align="center"
                      width="100px">
                    </el-table-column>
                    <el-table-column
                      label="DITERIMA"
                      prop="disetujui"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                        <span>{{ toMoney(scope.row.total_disetujui) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="DITOLAK"
                      prop="ditolak"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                        <span>{{ toMoney(scope.row.total_ditolak) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="PILIHAN" align="center" header-align="center" width="100px">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="Detail" placement="top-start">
                          <el-button type="primary" size="small" icon="ti-eye"  @click="confirmDet1(scope.row)"></el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" size="small" @click="dialogDet = false">Tutup</el-button>
                  </span>
                </el-dialog>

                <el-dialog :title="title1" :visible.sync="dialogDet1" v-loading="loadingModalDet1" width="1200px" top="1%">
                  <el-table border hover
                    :data="tableData8"
                    style="width: 100%; padding-bottom: 1px;" responsive>
                    <el-table-column
                      label="TANGGAL"
                      prop="tanggal"
                      header-align="center"
                      align="center"
                      width="100px">
                    </el-table-column>
                    <el-table-column
                      label="KETERANGAN"
                      prop="nama_barang"
                      header-align="left"
                      align="left">
                    </el-table-column>
                    <el-table-column
                      label="QTY"
                      prop="qty"
                      header-align="center"
                      align="center"
                      width="80px">
                    </el-table-column>
                    <el-table-column
                      label="HARGA"
                      prop="unit_price"
                      header-align="center"
                      align="center"
                      width="100px">
                      <template slot-scope="scope">
                        <span>{{ toMoney(scope.row.unit_price) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="TOTAL"
                      prop="total_price"
                      header-align="center"
                      align="center"
                      width="100px">
                      <template slot-scope="scope">
                        <span>{{ toMoney(scope.row.total_price) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="JENIS"
                      prop="jenis"
                      header-align="center"
                      align="center"
                      width="80px">
                    </el-table-column>
                    <el-table-column
                      label="STATUS"
                      prop="status"
                      header-align="center"
                      align="center"
                      width="100px">
                      <template slot-scope="scope">
                        <span v-if="scope.row.approve === 'T'">Ditolak</span>
                        <span v-else>Diterima</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="PILIHAN" align="center" header-align="center" width="250px">
                      <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.approve === 'Y'" class="item" effect="dark" content="Tolak" placement="top-start">
                          <el-button type="danger" size="small" icon="el-icon-error" @click="confirmDel(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-else class="item" effect="dark" content="Terima" placement="top-start">
                          <el-button type="success" size="small" icon="el-icon-check" @click="confirmAcc(scope.row)"></el-button>
                        </el-tooltip>
                        <!-- <span v-else>DITOLAK</span> -->
                        <el-tooltip class="item" effect="dark" content="Ubah Jenis" placement="top-start">
                          <el-button type="primary" size="small" icon="el-icon-refresh" @click="confirmUbah(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Edit" placement="top-start">
                          <el-button type="primary" size="small" icon="el-icon-edit" @click="confirmEdit2(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="Log" placement="top-start">
                          <el-button type="primary" size="small" icon="el-icon-time" @click="confirmLog(scope.row)"></el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" size="small" @click="dialogDet1 = false">Tutup</el-button>
                  </span>
                </el-dialog>

                <el-dialog :title="title2" :visible.sync="dialogDet2" v-loading="loadingModalDet2" width="1400px" top="1%">
                  <el-table border hover
                    :data="tableData9"
                    style="width: 100%; padding-bottom: 1px;" responsive>
                    <el-table-column
                      label="TANGGAL"
                      prop="tgl"
                      header-align="left"
                      align="left"
                      width="180px">
                    </el-table-column>
                    <el-table-column
                      label="KETERANGAN"
                      prop="nama_barang"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                        <span>{{ scope.row.nama_barang }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="QTY"
                      prop="qty"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                        <span>{{ toMoney(scope.row.qty) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="HARGA (RP)"
                      prop="unit_price"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                        <span>{{ toMoney(scope.row.unit_price) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="TOTAL (RP)"
                      prop="total_price"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                        <span>{{ toMoney(scope.row.total_price) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="JENIS"
                      prop="jenis"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                        <span>{{ scope.row.jenis }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="LOG"
                      prop="keterangan"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                        <span>{{ scope.row.keterangan }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="ADMIN"
                      prop="nama"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                        <span>{{ scope.row.nama }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogDet2 = false">Tutup</el-button>
                  </span>
                </el-dialog>

                
                <el-dialog title="Edit Data" :visible.sync="dialogFormEdit2" v-loading="loadingModalEdit2" width="500px" top="1%">
                  <el-form :model="formEdit" status-icon :rules="rules3" ref="formEdit2" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Keterangan" prop="nama_barang">
                      <el-input type="text" v-model="formEdit.nama_barang"></el-input>
                    </el-form-item>
                    <el-form-item label="Qty" prop="qty">
                      <el-input type="text" v-model="formEdit.qty" @keyup.native="onChangeQtyPrice()"></el-input>
                    </el-form-item>
                    <el-form-item label="Harga" prop="unit_price">
                      <el-input type="text" v-model="formEdit.unit_price" @keyup.native="onChangeQtyPrice()"></el-input>
                    </el-form-item>
                    <el-form-item label="Total" prop="total_price">
                      <el-input type="text" v-model="formEdit.total_price"></el-input>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEdit2 = false">Batal</el-button>
                      <el-button type="primary" @click="simpanEdit2(0, formEdit, 'formEdit2')">Simpan</el-button>
                    </span>
                </el-dialog>

                <!-- End of Basic Tables-->
                
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'Vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import VueCookie from 'vue-cookie'
    import moment from 'moment'
    Vue.use(VueCookie)

    import jsonUrl from '../../../assets/url.json'

    Vue.use(VueResource)

    import XLSX from 'xlsx'

    export default {
      name: 'Wilayah',
      components: {
        ClipLoader
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama wilayah'))
          } else {
            callback()
          }
        }
        var validateArea = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama area'))
          } else {
            callback()
          }
        }
        return {
          level: localStorage.level,
          toko1: '',
          blth: '',
          tableData7: [],
          tableData8: [],
          tableData9: [],
          title: '',
          title1: '',
          value4: new Date(),
          value6: '',
          bulan: '',
          tahun: '',
          row1: {kode: '', nama: '', edit: true},
          tableData: [],
          tableData1: [],
          tableData2: [],
          rules: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ]
          },
          rules2: {
            area: [
              { validator: validateArea, trigger: 'blur' }
            ]
          },
          cari_nama: '',
          cari_COGS: '',
          cari_OPR: '',
          cari_tanggal: '',
          filter_keterangan: '',
          nama: '',
          kode_toko: '',
          nama_toko: '',
          region: [],
          namas: [],
          pegawai: [],
          coba: false,
          fullscreenLoading: false,
          dialogFormEdit: false,
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormArea: false,
          loadingModal: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalArea: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          dialogFormInfo: false,
          dialogDet: false,
          loadingModalDet: false,
          dialogDet1: false,
          loadingModalDet1: false,
          dialogDet2: false,
          loadingModalDet2: false,
          dialogFormUbah: false,
          loadingModalUbah: false,
          dialogFormAcc: false,
          loadingModalAcc: false,
          dialogFormEdit2: false,
          loadingModalEdit2: false,
          form: {
            kode: '',
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            name: ''
          },
          form2: {
            kode: '',
            name: '',
            area: ''
          },
          formEdit: {
            kode: '',
            nama_barang: '',
            qty: '',
            unit_price: '',
            total_price: ''
          },
          message: '',
          formLabelWidth: 'auto',
          rules3: {
            nama: [
              { required: true, message: 'Silahkan isi nama device', trigger: 'blur' }
            ]
          },
          listQuery: {
            page: 1,
            limit: 20,
            importance: undefined,
            title: undefined,
            type: undefined,
            sort: 'none'
          },
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Nama A-Z', key: '+nama' }, { label: 'Nama Z-A', key: '-nama' }],
          total: null,
          page_size: 9999,
          current_page: 1
        }
      },
      methods: {
        getSummaries (param) {
          var { columns, data } = param
          var sums = []
          columns.forEach((column, index) => {
            if (index === 0) {
              sums[index] = 'TOTAL'
              return
            }

            var values = data.map(item => Number(item[column.property]))

            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                var value = Number(curr)
                if (!isNaN(value)) {
                  return prev + curr
                } else {
                  return prev
                }
              }, 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            } else {
              sums[index] = ''
            }
          })

          return sums
        },
        downloadExcelMonth: function () {
          /* eslint-disable */
          /* make the worksheet */
          var startDate = this.value6.toString().substr(0, 10)
          var endDate = this.value6.toString().substr(11, 10)
          
          const newJsonData = this.tableData.map(el => {
            delete el.kode_pengeluaran_harian_item
            delete el.edit
            delete el.no
            return el
          })

          var ws = XLSX.utils.json_to_sheet(newJsonData)

          /* add to workbook */
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet 1")

          /* generate an XLSX file */
          XLSX.writeFile(wb, 'PENGELUARAH_HARIAN_' + this.nama_toko +'.xlsx')
          /* eslint-disable */
        },
        querySearch1: function (queryString, cb) {
          var links = this.region.slice()
          var results = queryString ? links.filter(this.createFilter(queryString)) : links
          cb(results)
        },
        createFilter1 (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelect1 (item) {
          this.kode_toko = item.value
          this.nama_toko = item.label
          // this.getData()
        },
        toMoney (x) {
          var parts = x.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          return parts.join('.')
        },
        confirmDet: function (row) {
          this.dialogDet = true
          this.loadingModalDet = true
          this.tableData7 = []

          var req = {kode_toko: this.kode_toko, bulan: row.bulan, tahun: row.tahun}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/detail_bln'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalDet = false
              this.title = 'Detail pengeluaran ' + row.bulan + ' - ' + row.tahun
              this.tableData7 = response.body.data
            }
          }, response => {
            // error callback
            this.loadingModalDet = false
          })
        },
        confirmDet1: function (row) {
          this.dialogDet1 = true
          this.loadingModalDet1 = true
          this.tableData8 = []
          this.form1.tanggal = row.tanggal
          this.form1.bulan = row.bulan
          this.form1.tahun = row.tahun

          var req = {kode_toko: this.kode_toko, bulan: row.bulan, tahun: row.tahun, tanggal: row.tanggal}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/detail_tgl'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalDet1 = false
              this.title1 = 'Detail pengeluaran ' + row.tanggal + ' - ' + row.bulan + ' - ' + row.tahun
              this.tableData8 = response.body.data
            }
          }, response => {
            // error callback
            this.loadingModalDet1 = false
          })
        },
        confirmLog: function (row) {
          this.dialogDet2 = true
          this.loadingModalDet2 = true
          this.tableData9 = []

          var req = {kode_log: row.kode_pengeluaran_harian_item}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/log'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalDet2 = false
              this.title2 = 'Log #' + row.kode_pengeluaran_harian_item
              this.tableData9 = response.body.data
            }
          }, response => {
            // error callback
            this.loadingModalDet2 = false
          })
        },
        handleChangeDate: function () {
          // this.getData()
        },
        handleCurrentChangePegawai (val) {
          this.row1.nama = val.nama
          this.row1.kode_menu = val.kode
        },
        cariTanggal () {
          var nama = this.cari_tanggal
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.tanggal
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        filterKeterangan () {
          var nama = this.filter_keterangan
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama_barang
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariCOGS () {
          var nama = this.cari_COGS + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.COGS + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariOPR () {
          var nama = this.cari_OPR + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.OPR + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleFilter () {
          var byNama = this.tableData.slice(0)
          if (this.listQuery.sort === '+nama') {
            byNama.sort(function (a, b) {
              var x = a.nama.toLowerCase()
              var y = b.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.listQuery.sort === '-nama') {
            byNama.sort(function (a, b) {
              var x = b.nama.toLowerCase()
              var y = a.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else {
            byNama = this.tableData2.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData1 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          this.tableData1.push({kode: '', edit: true, nama: ''})
          for (var i = a; i < b; i++) {
            this.tableData1.push(this.tableData[i])
          }
        },
        submitForm: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('submit!')
            } else {
              console.log('error submit!!')
              return false
            }
          })
        },
        addData: function () {
          // this.tableData1.unshift({kode: '', nama: '', edit: true})
          this.dialogFormVisible = true
          this.clearForm()
        },
        clearForm: function () {
          this.row1 = {kode: '', nama: '', edit: true, tanggal_invoice: new Date(), tanggal: new Date()}
        },
        confirmEdit: function (j, row) {
          this.dialogFormEdit = true
          this.row1.kode = row.kode
          this.row1.nama = row.nama
          this.row1.id = row.id
        },
        cancelEdit: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            var item = this.tableData1[j]
            item.edit = false
            this.$set(this.tableData1, j, item)
          } else {
            this.tableData1.splice(j, 1)
          }
        },
        confirmEdit1: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (row.kode !== '') {
                this.loadingModalEdit = true
              } else {
                this.loadingModalAdd = true
              }
              this.dialogFormVisible = false
              this.dialogFormEdit = false

              var req = ''
              var action = '/'
              var tgl = moment(row.tanggal).format('YYYY-MM-DD')
              if (row.kode !== '') {
                req = {kode: row.kode, kode_toko: this.kode_toko, kode_menu: this.row1.kode_menu}
                action += 'update'
              } else {
                req = {kode_toko: this.kode_toko, nama: this.row1.nama, jumlah: this.row1.jumlah, tanggal: tgl}
                action += 'create'
              }
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + action

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormWilEdit = false
                  this.getData()
                  this.loadingModalEdit = false
                  this.loadingModalAdd = false
                  this.clearForm()
                  this.message = response.body
                  this.dialogFormInfo = true
                }
              }, response => {
                // error callback
                this.dialogFormWilEdit = false
                this.loadingModalEdit = false
                this.loadingModalAdd = false
                this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmDel: function (row) {
          this.form1.kode = row.kode_pengeluaran_harian_item
          this.keterangan = row.nama_barang
          this.blth = row.tanggal.substring(0, 7)
          this.dialogFormWilDel = true
        },
        confirmAcc: function (row) {
          this.form1.kode = row.kode_pengeluaran_harian_item
          this.keterangan = row.nama_barang
          this.blth = row.tanggal.substring(0, 7)
          this.dialogFormAcc = true
        },
        confirmDel1: function () {
          this.loadingModalDel = true
          var req = {kode_toko: this.kode_toko, kode_pengeluaran_harian_item: this.form1.kode, blth: this.blth}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/reject'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormWilDel = false
              this.loadingModalDel = false
              // var row = {tanggal: this.form1.tanggal, bulan: this.form1.bulan, tahun: this.form1.tahun}
              this.getData()
              // this.confirmDet(row)
              // this.confirmDet1(row)
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormWilDel = false
            this.loadingModalDel = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        confirmAcc1: function () {
          this.loadingModalAcc = true
          var req = {kode_toko: this.kode_toko, kode_pengeluaran_harian_item: this.form1.kode, blth: this.blth}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/accept'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormAcc = false
              this.loadingModalAcc = false
              // var row = {tanggal: this.form1.tanggal, bulan: this.form1.bulan, tahun: this.form1.tahun}
              this.getData()
              // this.confirmDet(row)
              // this.confirmDet1(row)
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormAcc = false
            this.loadingModalAcc = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        confirmUbah: function (row) {
          this.form1.kode = row.kode_pengeluaran_harian_item
          this.form1.name = row.nama_barang
          this.blth = row.tanggal.substring(0, 7)
          this.dialogFormUbah = true
        },
        confirmUbah1: function () {
          this.loadingUbah = true
          var req = {kode_toko: this.kode_toko, kode_pengeluaran_harian_item: this.form1.kode, blth: this.blth}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/ubah_jenis'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormUbah = false
              this.loadingModalUbah = false
              // var row = {tanggal: this.form1.tanggal, bulan: this.form1.bulan, tahun: this.form1.tahun}
              // this.confirmDet1(row)
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormUbah = false
            this.loadingModalUbah = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        confirmEdit2: function (row) {
          this.formEdit.kode = row.kode_pengeluaran_harian_item
          this.formEdit.nama_barang = row.nama_barang
          this.formEdit.qty = row.qty
          this.formEdit.unit_price = row.unit_price
          this.formEdit.total_price = row.total_price
          this.blth = row.tanggal.substring(0, 7)
          this.dialogFormEdit2 = true
        },
        simpanEdit2: function () {
          this.loadingModalEdit2 = true
          var req = {kode_toko: this.kode_toko, kode_pengeluaran_harian_item: this.formEdit.kode, nama_barang: this.formEdit.nama_barang, qty: this.formEdit.qty, unit_price: this.formEdit.unit_price, total_price: this.formEdit.total_price, blth: this.blth}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/update'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormEdit2 = false
              this.loadingModalEdit2 = false
              // var row = {tanggal: this.form1.tanggal, bulan: this.form1.bulan, tahun: this.form1.tahun}
              // this.confirmDet1(row)
              // this.confirmDet(row)
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormEdit2 = false
            this.loadingModalEdit2 = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        onChangeQtyPrice () {
          this.formEdit.total_price = this.formEdit.qty * this.formEdit.unit_price
        },
        // getData: function () {
        //   // this.loadingModal = true
        //   this.fullscreenLoading = true
        //   this.tableData = []
        //   this.tableData1 = []
        //   this.bulan = moment(this.value4).format('MM')
        //   this.tahun = moment(this.value4).format('YYYY')
        //   var c = this.current_page
        //   var req = {kode_toko: this.kode_toko, blth: moment(this.value4).format('YYYY-MM')}
        //   var req1 = JSON.stringify(req)

        //   var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/read_by_cutoff'
        //   // console.log(localStorage.session)

        //   Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
        //     // console.log('response ' + response.body[0].nama)
        //     if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
        //       this.$router.push('/login')
        //     } else {
        //       this.loadingModal = false
        //       // this.tableData1 = response.body.data.slice()
        //       this.tableData = response.body.data.slice()
        //       this.total = this.tableData.length
        //       for (var i = 0; i < this.tableData.length; i++) {
        //         this.tableData[i].edit = false
        //         this.tableData[i].no = i + 1
        //       }
        //       this.tableData2 = this.tableData.slice()
        //       var a = 0
        //       var b = a + this.page_size
        //       if (b > this.tableData.length) {
        //         b = this.tableData.length
        //       }
        //       for (var j = a; j < b; j++) {
        //         this.tableData1.push(this.tableData[j])
        //       }
        //       this.current_page = c
        //       this.handleCurrentChange(c)
        //       this.fullscreenLoading = false
        //     }
        //   }, response => {
        //     // error callback
        //     this.fullscreenLoading = false
        //   })
        // },
        getData: function () {
          // this.loadingModal = true
          this.fullscreenLoading = true
          this.tableData = []
          this.tableData1 = []
          // this.bulan = moment(this.value4).format('MM')
          // this.tahun = moment(this.value4).format('YYYY')

          var range = []
          var startDate = this.value6.toString().substr(0, 10)
          var endDate = this.value6.toString().substr(11, 10)
          var dateMove = new Date(startDate)
          var strDate = startDate

          if (strDate < endDate) {
            while (strDate < endDate) {
              strDate = dateMove.toISOString().slice(0, 10)
              range.push(strDate)
              dateMove.setDate(dateMove.getDate() + 1)
            }
          } else {
            range.push(strDate)
          }
          var c = this.current_page
          var req = {kode_toko: this.kode_toko, tanggal_filter: range}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_harian + '/read_by_date'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              // this.tableData1 = response.body.data.slice()
              this.tableData = response.body.data.slice()
              this.total = this.tableData.length
              for (var i = 0; i < this.tableData.length; i++) {
                this.tableData[i].edit = false
                this.tableData[i].no = i + 1
              }
              this.tableData2 = this.tableData.slice()
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData.length) {
                b = this.tableData.length
              }
              for (var j = a; j < b; j++) {
                this.tableData1.push(this.tableData[j])
              }
              this.current_page = c
              this.handleCurrentChange(c)
              this.fullscreenLoading = false
            }
          }, response => {
            // error callback
            this.fullscreenLoading = false
          })
        },
        getData1: function () {
          // this.loadingModal = true
          this.tableData = []
          this.tableData1 = []
          var req = {}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/read_simple'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.region = response.body.data.slice()
              for (var i = 0; i < this.region.length; i++) {
                this.region[i].value = this.region[i].kode + ''
                this.region[i].label = this.region[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_bulanan_pilihan + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.namas = response.body.data.slice()
              for (var i = 0; i < this.namas.length; i++) {
                this.namas[i].kode = this.namas[i].kode + ''
              }
            }
          }, response => {
            // error callback
          })
        }
      },
      mounted () {
        // if (localStorage.username !== 'root') {
        //   this.$router.replace('/toko')
        // }
        // this.loadingModal = true
        // this.getData()
        this.getData1()
      }
    }
</script>

<style>
  .edit-input {
    padding-right: 100px;
  }
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
</style>



// WEBPACK FOOTER //
// PengeluaranHarian1.vue?21e0e3c0